import React, { useState, useMemo } from 'react';
import { Widget, Table, ColumnProps } from '@digital/ui';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { compareNumber, compareDates, compareTypeNumber } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';

import { getByIdCrfPlanilhaOrcadoEconomicoAnoMes } from '@app/api/crf/crfProjeto';

interface CrfPlanilhaOrcadoEconomicoAnoMesTabelaProps {
  atualizarTelaProp: boolean;
  planilhaId: string;
}

const CrfPlanilhaOrcadoEconomicoAnoMesTabela = ({ atualizarTelaProp, planilhaId }: CrfPlanilhaOrcadoEconomicoAnoMesTabelaProps) => {
  const [colunasTabelaResult, setColunasTabela] = useState<ColumnProps<any>[]>();
  const [resultPlanilhaOrcadoEconomico, setResultPlanilhaOrcadoEconomico] = useState();

  const getAllOrdemInvestimento = useMemo(async () => {
    if (planilhaId) {
      const result: any = await getByIdCrfPlanilhaOrcadoEconomicoAnoMes(planilhaId);
      if (result) {
        if (result.nomeColunasDinamicas) {
          const colunaNome = result.nomeColunasDinamicas as string[];
          setColunasTabela(result.columnProps);
          setResultPlanilhaOrcadoEconomico(result.tabelaPlanilhaOrcadoEconomico);
        }
      }
    }
  }, [planilhaId, atualizarTelaProp]);

  const colunasTabela = useMemo(() => {
    const actions = [];
    actions.push(
      {
        title: 'Centro de Custo',
        dataIndex: 'numeroCentroDeCusto',
        width: '3%',
        ...mountFormFilterDropDown("numeroCentroDeCusto", "Pesquisar por centro de custo"),
        sorter: (a: any, b: any) => compareNumber(a.numeroCentroDeCusto, b.numeroCentroDeCusto),
      },
      {
        title: 'Conta Contábil',
        dataIndex: 'crfContaContabilCodigo',
        width: '3%',
        ...mountFormFilterDropDown("crfContaContabilCodigo", "Pesquisar por conta contábil"),
        sorter: (a: any, b: any) => compareNumber(a.crfContaContabilCodigo, b.crfContaContabilCodigo),
      },
      {
        title: 'Número',
        dataIndex: 'numero',
        width: '3%',
        ...mountFormFilterDropDown("numero", "Pesquisar por número"),
        sorter: (a: any, b: any) => compareTypeNumber(a.numero, b.numero),
      },
      {
        title: 'Revisão',
        dataIndex: 'revisao',
        width: '3%',
        ...mountFormFilterDropDown("revisao", "Pesquisar por revisão"),
        sorter: (a: any, b: any) => compareTypeNumber(a.revisao, b.revisao),
      },
      {
        title: 'Data de Aprovação',
        dataIndex: 'dataAprovacao',
        width: '5%',
        sorter: (a: any, b: any) => compareDates(a.dataAprovacao, b.dataAprovacao),
        ...mountFormFilterDropDown("dataAprovacao", "Pesquisar por data de aprovação"),
      },
    );

    if (colunasTabelaResult) {
      colunasTabelaResult.forEach(coluna => {
        actions.push({
          title: coluna.title,
          dataIndex: coluna.dataIndex,
          key: coluna.dataIndex,
          width: coluna.width,
        });
      });
    }
    return actions;
  }, [colunasTabelaResult, atualizarTelaProp]);

  return (
    <>
      <Widget title="Orçado Econômico">
        <PerfectScrollbar>
          <Table
            className="multiple-level-table tabelas-orcado-crf"
            columns={colunasTabela}
            dataSource={resultPlanilhaOrcadoEconomico}
            pagination={false}
          />
        </PerfectScrollbar>
      </Widget>
    </>
  );
};

export default CrfPlanilhaOrcadoEconomicoAnoMesTabela;
